import { render, staticRenderFns } from "./TeremGameStatisticsScreen.vue?vue&type=template&id=2cde0b8a&scoped=true&"
import script from "./TeremGameStatisticsScreen.vue?vue&type=script&lang=js&"
export * from "./TeremGameStatisticsScreen.vue?vue&type=script&lang=js&"
import style0 from "./TeremGameStatisticsScreen.vue?vue&type=style&index=0&id=2cde0b8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde0b8a",
  null
  
)

export default component.exports